import { Card } from '@repo/shadcn';
import { toast } from 'sonner';

import { SectionContainer } from '@components/shared';
import { HeaderBreadcrumb } from '@components/ui';

import { Route } from '@/constants';

import { useCreateNewProductMutation } from '../../../../features/slice/products/product/productApiSlice';
import { toastError } from '../../../../utils';
import { ProductForm } from '../product-form';

export const CreateProduct = () => {
    const [createNewProduct, { isLoading }] = useCreateNewProductMutation();

    const handleSubmit = async (data: any) => {
        const payload = {
            name: data.name,
            name_id: data.name_id,
            shelf: data.shelf ?? '',
            brand_id: data.brand_id,
            generic_id: data.generic_id,

            variations: [
                {
                    type_id: data.type_id,
                    strength_id: data.strength_id,
                    unit_id: data.unit_id,
                    alert_quantity: Number(data.alert_quantity),
                    purchase_price: Number(data.purchase_price),
                    wholesale_price: Number(data.wholesale_price),
                    retail_price: Number(data.retail_price),
                },
            ],
        };

        try {
            await createNewProduct(payload).unwrap();
            toast.success('Product created successfully');
        } catch (error) {
            toastError(error, 'CreateProduct: handleSubmit');
        }
    };

    return (
        <SectionContainer>
            <Card className={'space-y-4 p-4'}>
                <div>
                    <HeaderBreadcrumb
                        items={[
                            { label: 'Products', href: Route.PRODUCTS },
                            { label: 'Create New Product' },
                        ]}
                    />
                </div>

                <ProductForm
                    initialValues={{
                        name: '',
                        name_id: '',
                        // @ts-expect-error - It needs to stay empty initially
                        alert_quantity: '',

                        // @ts-expect-error - It needs to stay empty initially
                        purchase_price: '',
                        // @ts-expect-error - It needs to stay empty initially
                        retail_price: '',
                        // @ts-expect-error - It needs to stay empty initially
                        wholesale_price: '',

                        brand_id: '',
                        brand_name: '',

                        generic_id: '',
                        generic_name: '',

                        strength_id: '',
                        strength_name: '',

                        type_id: '',
                        type_name: '',

                        unit_id: '',
                        unit_name: '',

                        shelf: '',
                    }}
                    onSubmit={handleSubmit}
                    isLoading={isLoading}
                    title="Create Product"
                />
            </Card>
        </SectionContainer>
    );
};

CreateProduct.displayName = 'CreateProduct';
